import React, { useEffect, useState } from 'react'
import { Card, Typography, Spin } from 'antd'
import { QRCodeCanvas } from 'qrcode.react'
import axiosInstance from '../Utils/axiosInstance'
import { getQrScannerData, LastGeneratedQR } from "../API's/UserApi"

const { Title, Text } = Typography

const ViewQRCode = () => {
  const [qrValue, setQrValue] = useState('')
  const [loading, setLoading] = useState(false)
  const [slotData, setSlotData] = useState(null)

  useEffect(() => {
    fetchQrCode()
  }, [])

  const fetchQrCode = async () => {
    try {
      setLoading(true)

      const userData = JSON.parse(sessionStorage.getItem('userData'))
      const mobileNo = userData?.mobileNo

      const res = await axiosInstance.get(
        `${LastGeneratedQR}?mobileNo=${mobileNo}`,
      )

      setQrValue(res.data.qrToken)

      setSlotData({
        date: res.data.date,
        from: res.data.timeFrom,
        to: res.data.timeTo,
      })
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div style={{ display: 'flex', justifyContent: 'center', marginTop: 40 }}>
      <Card style={{ width: 400, textAlign: 'center' }}>
        <Text
          type="secondary"
          style={{
            display: 'block',
            marginBottom: 10,
            color: 'red',
            fontWeight: 'bold',
          }}
        >
          Note: This QR code displays your most recent transaction only.
        </Text>

        <Title level={3}>Your Booking QR</Title>

        {loading ? (
          <Spin />
        ) : qrValue ? (
          <>
            <QRCodeCanvas
              value={`${getQrScannerData}?token=${qrValue}`}
              size={250}
            />

            {slotData && (
              <div style={{ marginTop: 20 }}>
                <Title level={5} style={{ marginBottom: 5 }}>
                  Booking Details
                </Title>

                <Text strong>
                  Date: {slotData.date}
                </Text>

                <br />

                <Text strong>
                  Slot Time: {slotData.from} - {slotData.to}
                </Text>
              </div>
            )}
          </>
        ) : (
          <p>No QR data available</p>
        )}
      </Card>
    </div>
  )
}

export default ViewQRCode
